/// <amd-module name="Test/Analytics/ReleaseHelper/Service/ReleaseService/ReleaseAnalyticsDataService" />
import { IAnalyticsDataService } from "Analytics/Shared/Common/Types";
import * as Resources from "Test/Analytics/ReleaseHelper/Service/ReleaseService/Resources";
import * as Release from "Test/Release/Client/Contracts/Release";
import { getReleaseClient } from "Test/Release/Client/RestClient/Release";
import { ITfsPageService } from "Tfs/Platform/Page";
import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { routeUrl } from "VSS/Platform/Location";

export class ReleaseAnalyticsDataService extends VssService implements IAnalyticsDataService {
    private static readonly _releaseHubActionAnalytics: string = "mine";
    private static readonly _release_a_parameter: string = "analytics";
    private static readonly _releaseHubRouteUrl: string = "ms.vss-releaseManagement-web.hub-explorer-3-default-route";

    private _releaseClientContentPromise: Promise<void> | undefined;
    private _releaseDefinitionName: string;

    public async fetchDefinitionName(definitionId: number): Promise<string> {
        if (!this._releaseDefinitionName) {
            const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
            const tfsPageData = tfsPageService.getData();
            if (tfsPageData && tfsPageData.project) {
                const project = tfsPageData.project.name;

                await this._getReleaseClientContent();
                const releaseRestClient = getReleaseClient(this.pageContext);
                const releaseDefinitionInfo = await releaseRestClient.getReleaseDefinition(project, definitionId);
                this._releaseDefinitionName = releaseDefinitionInfo.name;
            } else {
                throw new Error(Resources.FailedToFetchProjectDetailsErrorText);
            }
        }

        return this._releaseDefinitionName;
    }

    public getDefinitionUrl(definitionId: number): string {
        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");

        const tfsPageData = tfsPageService.getData();
        if (tfsPageData && tfsPageData.project) {
            const project = tfsPageData.project.name;
            const url = routeUrl(this.pageContext, ReleaseAnalyticsDataService._releaseHubRouteUrl, {
                project: project,
                definitionId: definitionId.toString()
            });
            return url;
        } else {
            throw new Error(Resources.FailedToFetchProjectDetailsErrorText);
        }
    }

    public getAnalyticsCardMetricsUrl(definitionId: number): string {
        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");

        const tfsPageData = tfsPageService.getData();
        if (tfsPageData && tfsPageData.project) {
            const project = tfsPageData.project.name;
            const url = routeUrl(this.pageContext, ReleaseAnalyticsDataService._releaseHubRouteUrl, {
                project: project,
                definitionId: definitionId.toString(),
                _a: ReleaseAnalyticsDataService._release_a_parameter,
                view: ReleaseAnalyticsDataService._releaseHubActionAnalytics
            });
            return url;
        } else {
            throw new Error(Resources.FailedToFetchProjectDetailsErrorText);
        }
    }

    private _getReleaseClientContent(): Promise<void> {
        if (!this._releaseClientContentPromise) {
            const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
            this._releaseClientContentPromise = contributionService.getContributionAsync("ms.vss-test-web.release-client");
        }
        return this._releaseClientContentPromise;
    }
}

Services.add("IReleaseAnalyticsDataService", { serviceFactory: ReleaseAnalyticsDataService });
